module.exports = __webpack_public_path__ + "static/media/tulips.427faf77.jpg";